import React from 'react';
import { StyledLink } from './styled';
export const Link = ({ linkRef = undefined, children, ...props }) => {
    return (React.createElement(StyledLink, { ref: linkRef, ...props }, children));
};
